import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import {
  Form,
  TextfieldElement,
  FormHeader,
  FormFooter,
  SubHeading,
  CheckboxElement,
  Button,
  FormSubmit,
  Role,
  SelectElement,
  FormMandatoryPrompt,
  withProvidersApi,
  AutocompleteTextfieldApiElement,
} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import i18n from "../../../i18n";
import moment from "moment";
import { ACTION_SAVE, LANGUAGE_EN, ROLE_STAFF } from "../../../constants";

class ContactsCreateEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasManualContactName: this.props.values["contactName_" + this.props.inputLanguage] === "" ? false : true,
    };



  }

  componentDidUpdate(prevProps) {
    if (
      this.props.values["contactName_" + this.props.inputLanguage] &&
      prevProps.values["contactName_" + this.props.inputLanguage] === ""
    ) {
      this.setState({
        hasManualContactName: true,
      });
    }
  }

  /**
   * render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        {this.props.values.status && (
          <p>
            <strong>
              {this.props.t(
                "local:view.contacts.edit.field.currentStatus.label"
              )}
            </strong>{" "}
            {this.props.courses.getStatusName(this.props.values.status)}
          </p>
        )}

        {this.props.audit && this.props.audit.createdBy && (
          <p>
            <strong>
              {this.props.t("local:view.contacts.edit.field.createdBy.label")}
            </strong>
            : {this.props.audit.createdBy.name}{" "}
            {moment(this.props.audit.dateCreated).format("DD/MM/YYYY HH:mm:ss")}
          </p>
        )}

        {this.props.audit && this.props.audit.updatedBy && (
          <p>
            <strong>
              {this.props.t("local:view.contacts.edit.field.updatedBy.label")}
            </strong>
            : {this.props.audit.updatedBy.name}{" "}
            {moment(this.props.audit.dateUpdated).format("DD/MM/YYYY HH:mm:ss")}
          </p>
        )}

        <SubHeading type={"sub-heading-small"} colour={"sub-heading-small--b"}>
          {this.props.inputLanguage === LANGUAGE_EN
            ? i18n.t("styleguide:languages.englishVersion")
            : i18n.t("styleguide:languages.welshVersion")}
        </SubHeading>
        <Form>
          <FormHeader
            title={this.props.t(
              "local:view.contacts." + this.props.mode + ".formTitle"
            )}
            introduction={this.props.t(
              "local:view.contacts." + this.props.mode + ".formDescription"
            )}
          >
            <FormMandatoryPrompt />
          </FormHeader>

          <Role roles={[ROLE_STAFF]}>
            <AutocompleteTextfieldApiElement
              api={this.props.providersApiGetEndpoint("providers_api_provider")}
              authorize={true}
              size={"large"}
              anchorId={"atlasAccount.atlasAccountId"}
              name={"atlasAccount"}
              label={this.props.t(
                "local:view.contacts.create.field.atlasAccountId.label"
              )}
              disabled={this.props.mode === "edit"}
              queryParameter={"name"}
              acceptLanguage={i18n.language}
              keyField={"atlasAccountId"}
              valueField={"providerName"}
              required={true}
              placeholder={this.props.t(
                "local:view.contacts.create.field.atlasAccountId.placeholder"
              )}
              value={this.props.values.atlasAccountId}
              keyword={this.props.values.atlasAccountLabel}
              errors={this.props.formErrors["atlasAccount.atlasAccountId"]}
              onChange={this.props.handleChange}
            />
          </Role>

          {/* ContactName  */}

            <SelectElement
              size={"medium"}
              label={this.props.t(
                "local:view.contacts.create.field.contactNameSelect.label"
              )}
              description={this.props.t(
                "local:view.contacts.create.field.contactNameSelect.description"
              )}
              id={"contactNameSelect"}
              name={"contactNameSelect"}
              value={this.props.values["contactNameSelect"]}
              onChange={(event) => {
                this.props.handleContactNameSelect(
                  event,
                  this.props.inputLanguage,
                  this.props.courses.assets.contacts
                );
              }}
              onKeyPress={this.context.preventDefaultOnEnter}
              hasButton={true}
              options={[
                {
                  value: "",
                  label: this.props.t("styleguide:forms.pleaseSelect"),
                },
              ].concat(
                this.props.courses.assets.contacts.contactType[
                  this.props.inputLanguage
                ]
              )}
              suffix={
                !(
                  this.state.hasManualContactName ||
                  this.props.manualContactName
                ) && (
                  <Fragment>
                    {this.props.t("styleguide:or")}{" "}
                    <Button
                      onClick={this.props.handleManualContactName}
                      asLink={true}
                    >
                      {this.props.t(
                        "local:view.contacts.create.field.manualContactName.label"
                      )}
                    </Button>
                  </Fragment>
                )
              }
            />


          {/* ContactName */}
          {(this.state.hasManualContactName ||
            this.props.manualContactName ||
            this.props.formErrors[
              "contactName_" + this.props.inputLanguage
            ]) && (
            <TextfieldElement
              size={"medium"}
              label={this.props.t(
                "local:view.contacts.create.field.contactName.label"
              )}
              id={"contactName_" + this.props.inputLanguage}
              description={this.props.t(
                "local:view.contacts.create.field.contactName.description"
              )}
              required={true}
              name={"contactName_" + this.props.inputLanguage}
              value={
                this.props.values["contactName_" + this.props.inputLanguage]
              }
              onChange={this.props.handleChange}
              errors={
                this.props.formErrors["contactName_" + this.props.inputLanguage]
              }
              onKeyPress={this.context.preventDefaultOnEnter}
            />
          )}

          {/* telephoneNumber */}
          <TextfieldElement
            size={"medium"}
            label={this.props.t(
              "local:view.contacts.create.field.telephoneNumber.label"
            )}
            id={"telephoneNumber_" + this.props.inputLanguage}
            description={this.props.t(
              "local:view.contacts.create.field.telephoneNumber.description"
            )}
            name={"telephoneNumber_" + this.props.inputLanguage}
            value={
              this.props.values["telephoneNumber_" + this.props.inputLanguage]
            }
            onChange={this.props.handleChange}
            errors={
              this.props.formErrors[
                "telephoneNumber_" + this.props.inputLanguage
              ]
            }
            onKeyPress={this.context.preventDefaultOnEnter}
          />

          {/* mobileNumber */}
          <TextfieldElement
            size={"medium"}
            label={this.props.t(
              "local:view.contacts.create.field.mobileNumber.label"
            )}
            id={"mobileNumber"}
            description={this.props.t(
              "local:view.contacts.create.field.mobileNumber.description"
            )}
            name={"mobileNumber"}
            value={this.props.values["mobileNumber"]}
            onChange={this.props.handleChange}
            errors={this.props.formErrors["mobileNumber"]}
            onKeyPress={this.context.preventDefaultOnEnter}
          />

          {/* email */}
          <TextfieldElement
            size={"medium"}
            label={this.props.t("local:view.contacts.create.field.email.label")}
            id={"email_" + this.props.inputLanguage}
            description={this.props.t(
              "local:view.contacts.create.field.email.description"
            )}
            name={"email_" + this.props.inputLanguage}
            value={this.props.values["email_" + this.props.inputLanguage]}
            onChange={this.props.handleChange}
            errors={this.props.formErrors["email_" + this.props.inputLanguage]}
            onKeyPress={this.context.preventDefaultOnEnter}
          />

          {this.props.values.confirmationDate && (
            <p>
              <strong>
                {this.props.t(
                  "local:view.contacts.create.field.confirmationDate.label"
                )}
              </strong>{" "}
              {moment(this.props.values.confirmationDate).format("DD/MM/YYYY")}
            </p>
          )}
          {this.props.values.id && (
            <CheckboxElement
              onChange={this.props.handleChange}
              id={"confirmedAccurate"}
              name={"confirmedAccurate"}
              checked={this.props.values.confirmedAccurate.has("1")}
              value={"1"}
              label={this.props.t(
                "local:view.contacts.create.field.confirmedAccurate.label"
              )}
            />
          )}

          <FormFooter>
            <FormSubmit
              title={"Submit"}
              value={"Submit"}
              icon={{ type: "chevron-right", position: "right" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.saveContact(
                  this.props.getSaveState(this.props.values.status, ACTION_SAVE)
                );
              }}
              spinner={this.props.submitting ? "spinner" : null}
            >
              {this.props.t("styleguide:forms.save")}
            </FormSubmit>
          </FormFooter>
        </Form>
      </Fragment>
    );
  }
}

export default withProvidersApi(process.env)(
  withAssets(withTranslation("local")(ContactsCreateEditForm))
);
